// Cognito Configuration
// Production configuration for QueueMeIn

// Environment-specific config via build variables
const DEFAULT_COGNITO_CONFIG = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  oauth: {
    domain: import.meta.env.VITE_COGNITO_DOMAIN,
    scope: ['openid', 'email', 'profile', 'phone'],
    redirectSignIn: [
      window.location.origin + '/'
    ],
    redirectSignOut: [
      window.location.origin + '/'
    ],
    responseType: 'token'
  }
}

// Dynamic config that gets loaded based on subdomain
let dynamicConfig: any = null
let configLoaded = false

export const COGNITO_CONFIG = new Proxy(DEFAULT_COGNITO_CONFIG, {
  get(target, prop) {
    // If dynamic config is loaded and has this property, use it
    if (dynamicConfig && prop in dynamicConfig) {
      const value = dynamicConfig[prop]
      // For nested objects like 'oauth', create a nested proxy
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        return new Proxy(value, {
          get(nestedTarget: any, nestedProp) {
            return nestedTarget[nestedProp]
          }
        })
      }
      return value
    }
    // Otherwise use default config
    const value = target[prop as keyof typeof target]
    // For nested objects in default config, also create proxy for consistency
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      return new Proxy(value, {
        get(nestedTarget: any, nestedProp) {
          return nestedTarget[nestedProp]
        }
      })
    }
    return value
  }
})

// Check if tenant config is loaded
export function isTenantConfigLoaded(): boolean {
  return configLoaded
}

// Function to load tenant-specific Cognito config
export async function loadTenantCognitoConfig(tenantId: string): Promise<void> {
  try {
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || (() => {
      // Environment-specific fallback based on hostname
      const hostname = window.location.hostname
      if (hostname.includes('dev.queuemein.com')) return 'https://api.dev.queuemein.com'
      if (hostname.includes('test.queuemein.com')) return 'https://api.test.queuemein.com'
      return 'https://api.' + 'queuemein.com' // production fallback
    })()
    const response = await fetch(`${apiBaseUrl}/admin/tenant/${tenantId}/cognito-config`)
    
    if (response.ok) {
      const config = await response.json()
      
      dynamicConfig = {
        userPoolId: config.user_pool_id,
        userPoolWebClientId: config.cognito_client_id,
        oauth: {
          domain: config.cognito_domain || import.meta.env.VITE_COGNITO_DOMAIN,
          scope: ['openid', 'email', 'profile', 'phone'],
          redirectSignIn: [window.location.origin + '/'],
          redirectSignOut: [window.location.origin + '/'],
          responseType: 'token'
        }
      }
      console.log('Loaded tenant Cognito config:', {
        clientId: dynamicConfig.userPoolWebClientId,
        domain: dynamicConfig.oauth.domain,
        tenantId
      })
      configLoaded = true
    } else {
      configLoaded = true // Still mark as loaded to show login form
    }
  } catch (error) {
    console.error('Error loading Cognito config:', error)
    configLoaded = true // Still mark as loaded to show login form
  }
}

